module.exports = __webpack_public_path__ + "img/menubuilder.e7eb5b43.svg";